module.exports = __webpack_public_path__ + "img/selected5-min.fd50cd8e.png";